/**
 * Boten Service - API calls voor boten
 */

import apiFetch from './api';
import { BootModel } from './bootModellen.service';
import { Relation } from './relations.service';

export interface Boot {
  id: number;
  boot_model_id: number;
  eigenaar_id: number;
  bootnaam?: string;
  registratienummer?: string;
  bouwjaar?: number;

  // Specificaties (voor generieke boot modellen)
  lengte?: number;
  breedte?: number;
  diepgang?: number;
  gewicht?: number;
  materiaal?: string;

  ligplaats?: string;
  mmsi?: string;
  opmerkingen?: string;
  actief: boolean;
  created_at: string;
  updated_at?: string;
}

export interface BootDetail extends Boot {
  boot_model: BootModel;
  eigenaar?: Relation;
}

export interface BootCreate {
  boot_model_id: number;
  eigenaar_id: number;
  bootnaam?: string;
  registratienummer?: string;
  bouwjaar?: number;

  // Specificaties (voor generieke boot modellen)
  lengte?: number;
  breedte?: number;
  diepgang?: number;
  gewicht?: number;
  materiaal?: string;

  ligplaats?: string;
  mmsi?: string;
  opmerkingen?: string;
  actief?: boolean;
}

export interface BootFilters {
  skip?: number;
  limit?: number;
  actief?: boolean;
  eigenaar_id?: number;
  zoek?: string;
  sorteer?: string;
  richting?: string;
}

export const botenService = {
  async getAll(filters: BootFilters = {}): Promise<BootDetail[]> {
    const params = new URLSearchParams();

    if (filters.skip !== undefined) params.append('skip', filters.skip.toString());
    if (filters.limit !== undefined) params.append('limit', filters.limit.toString());
    if (filters.actief !== undefined) params.append('actief', filters.actief.toString());
    if (filters.eigenaar_id !== undefined) params.append('eigenaar_id', filters.eigenaar_id.toString());
    if (filters.zoek) params.append('zoek', filters.zoek);
    if (filters.sorteer) params.append('sorteer', filters.sorteer);
    if (filters.richting) params.append('richting', filters.richting);

    return apiFetch(`/api/v1/boten?${params.toString()}`);
  },

  async getById(id: number): Promise<BootDetail> {
    return apiFetch(`/api/v1/boten/${id}`);
  },

  async create(data: BootCreate): Promise<Boot> {
    return apiFetch('/api/v1/boten', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  async update(id: number, data: Partial<BootCreate>): Promise<Boot> {
    return apiFetch(`/api/v1/boten/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },

  async delete(id: number): Promise<void> {
    return apiFetch(`/api/v1/boten/${id}`, {
      method: 'DELETE',
    });
  },
};
